import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreState } from 'src/app/state/_state.interfaces';
import { getUserInfo, getShowMenu } from 'src/app/state/_state.selectors';
import { LogoutSessions } from 'src/app/state/session.actions';
import { SideNavNavigation } from 'src/app/state/nav.actions';

/**
 * サイドナビー
 */
@Component({
  selector: 'app-sidenav-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavContentComponent {
  /** メニュー項目 */
  menuItems$: Observable<{label: string; menuItems: {label: string; path?: string}[]}[]>;
  /** メニュー表示 */
  showMenu$: Observable<boolean>;

  /**
   * コンストラクタ
   */
  constructor(
    private store: Store<CoreState>
  ) {
    this.menuItems$ = this.store.select(getUserInfo).pipe(map(userInfo => userInfo ? userInfo.menu : []));
    this.showMenu$ = this.store.select(getShowMenu);
  }

  /**
   * ナビゲーション
   */
  public navigate(path: string) {
    if (path) {
      this.store.dispatch(new SideNavNavigation({ url: path }));
    }
  }

  /**
   * ログアウト
   */
  logout() {
    this.store.dispatch(new LogoutSessions());
  }
}
